import React, { useState, useEffect } from 'react';
import { BringzzButton, BringzzText } from "@bringzz/components";
import { useParams } from 'react-router-dom';
import { useNavigation } from 'context/NavigationContext';
import { useOverlay } from 'context/OverlayContext';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzProgressBar,
    BringzzBottomDrawer,
    BringzzRadioList,
    BringzzRadio,
    BringzzInput
} from "@bringzz/components";
import { useSocket } from 'context/SocketClusterContext';
import useRequest from 'hooks/useRequest';
import { customerPickupSegments, customerCollectSegments, customerMailSegments } from 'constants/orderSegments';
import { useOrder } from 'context/OrderContext';
import BringzzPharmacyCardSmall from 'components/BringzzPharmacyCardSmall';
import BringzzOrderCardSmallAccordion from 'components/BringzzOrderCardSmallAccordion';
import BringzzShopperCardSmall from 'components/BringzzShopperCardSmall';
import { InvoiceView } from 'components/InvoiceStep';
import ImageViewerModal from 'components/ImageViewerModal';
import { ORDER_STATUS, DELIVERY_TYPES } from 'utils/constants';
import { ORDER_TYPES } from 'hooks/useActiveOrderChecker';

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const MatchmakingCustomerPage = () => {
    const { backPress, navigate } = useNavigation();
    const { step } = useParams();
    const [activeStep, setActiveStep] = useState(step ? parseInt(step, 10) : 0);
    const [selectedTip, setSelectedTip] = useState(null);
    const [cancelOrderDrawer, setCancelOrderDrawer] = useState(false)
    const [selectedReason, setSelectedReason] = useState()
    const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [modalInvoice, setModalInvoice] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalError, setModalError] = useState(null);
    const { showOverlayContent, hideOverlay } = useOverlay();
    const { onRefetchData } = useSocket();
    const { sendRequest, loading } = useRequest();
    const { orderDetails, activeStep: contextActiveStep, stopMatchingProcess, resetOrderContext, refetchOrder, prescriptionInfo, invoiceData, fetchInvoiceData } = useOrder()

    // Helper function to format UTC date to user's local timezone
    const formatOrderReadyTime = (utcDateString) => {
        if (!utcDateString) return '';

        try {
            // The date format from API is "05.10.2025 22:23" in UTC
            const [date, time] = utcDateString.split(' ');
            const [day, month, year] = date.split('.');
            const [hours, minutes] = time.split(':');

            // Create date in UTC then it will automatically be displayed in local time
            const dateObj = new Date(Date.UTC(year, month - 1, day, hours, minutes));

            // Format the date in user's local timezone
            const options = {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            };

            return dateObj.toLocaleString('en-US', options);
        } catch (error) {
            // Fallback to original string if parsing fails
            return utcDateString;
        }
    };

    let segments = customerPickupSegments({ navigate, loading }); // Default fallback
    if (orderDetails?.type == DELIVERY_TYPES.BRINGZZ_PICKUP) {
        segments = customerPickupSegments({ navigate, loading });
    } else if (orderDetails?.type == DELIVERY_TYPES.CLICK_AND_COLLECT) {
        segments = customerCollectSegments({ navigate, loading });
    } else if (orderDetails?.type == DELIVERY_TYPES.MAIL_DELIVERY) {
        segments = customerMailSegments({ navigate, loading });
    }

    const handleCancelOrderDrawer = async () => {
        setCancelOrderDrawer(!cancelOrderDrawer)
    }

    const handleCancelOrder = async () => {
        await sendRequest({
            method: 'POST',
            url: `/module/order/cancelOrder`,
            data: {
                "orderId": orderDetails?.id
            }
        }).then((response) => {
            if (response.status === 'success') {
                navigate('/matchmaking/customer/cancelled')
                stopMatchingProcess()
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    const handleShowOverlay = () => {
        showOverlayContent(
            <div className='h-full w-full bg-white'>
                <div className='flex justify-between p-4'>
                    <div>
                        <BringzzIcon
                            size='22'
                            icon='IconClose'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={hideOverlay}
                        />
                    </div>
                    <div>
                        <BringzzText tag='h3'>Cancellation fees</BringzzText>
                    </div>
                    <div></div>
                </div>
                <div className='p-4 space-y-2'>
                    <BringzzText tag='h3'>Cancellation fees</BringzzText>
                    <BringzzText tag='h4' className='font-normal'>The cancellation is free with in the first 60 sec, after that we will charge our service fee of 99cents. And depending on the process progress we will charge an additional cancellation fee of 5,99 EUR to compensate ... </BringzzText>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const cleanupRefetchData = onRefetchData((data) => {
            console.log({ data });
            if (data?.notificationType?.includes("ORDER_PROGRESS_")) {
                const stepNumber = data.notificationType.split("_")[2];
                if (stepNumber) {
                    return setActiveStep(stepNumber);
                }
            }
            return;
        });

        refetchOrder()

        return () => {
            if (cleanupRefetchData) {
                cleanupRefetchData();
            }
        };
    }, [onRefetchData])

    // Sync local step with context (covers socket-down polling updates)
    useEffect(() => {
        if (typeof contextActiveStep === 'number') {
            setActiveStep(contextActiveStep);
        }
    }, [contextActiveStep]);

    useEffect(() => {
        if (orderDetails?.id && !invoiceData) {
            fetchInvoiceData(orderDetails.id).catch(err => {
                console.error('Failed to fetch invoice data:', err);
            });
        }
        if (invoiceData) {
            setModalInvoice(invoiceData);
        }
    }, [orderDetails?.id, invoiceData, fetchInvoiceData])

    const selectTip = amount => {
        setSelectedTip(amount); // Update the selected tip
    };

    useEffect(() => {
        console.log('MatchmakingCustomerPage - orderDetails check:', orderDetails);
        const savedState = localStorage.getItem('orderContext');
        console.log('MatchmakingCustomerPage - localStorage orderContext:', savedState);

        if (!orderDetails) {
            console.log('No orderDetails found, redirecting to home');
            resetOrderContext();
            navigate('/home');
        }
    }, [orderDetails, navigate, resetOrderContext]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (orderDetails && orderDetails?.deliveryStatus == ORDER_STATUS.DONE) {
                navigate('/matchmaking/customer/completed');
            }
        }, 2000);

        return () => clearTimeout(timer);
    }, [orderDetails?.deliveryStatus, navigate]);

    const handleShowInvoiceModal = async () => {
        setShowInvoiceModal(true);
        setModalLoading(true);
        setModalError(null);
        
        try {
            const invoice = await fetchInvoiceData(orderDetails?.id);
            setModalInvoice(invoice);
        } catch (err) {
            setModalError('Failed to fetch invoice.');
        } finally {
            setModalLoading(false);
        }
    };

    const handleDownloadModalInvoice = async () => {
        if (!modalInvoice) return;
        setModalError(null);
        setModalLoading(true);
        try {
            const response = await sendRequest({
                method: 'POST',
                url: '/module/order/downloadCustomerInvoicePdf',
                data: { orderId: orderDetails?.id },
                responseType: 'json',
            });
            if (response.status === 'success' && response.data && response.data.content) {
                const { content, filename } = response.data;
                const base64 = content.split(',')[1];
                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename || `customer_invoice_${orderDetails?.id}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } else {
                setModalError('Failed to download PDF.');
            }
        } catch (err) {
            setModalError('Failed to download PDF.');
        } finally {
            setModalLoading(false);
        }
    };

    if (!orderDetails) {
        return null;
    }

    return (
        <BringzzPageContainer
            className="bg-white"
            header={{
                title: `Order #${orderDetails?.id || ''}`,
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconClose'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={() => navigate('/home')}
                    />
                ),
                right: (
                    <BringzzButton
                        className='border border-black'
                        size='sm'
                    // onClick={() => navigate('/instruction')}
                    >
                        Help
                    </BringzzButton>
                )
            }}
            authenticated={true}
        >
            <div className='px-6 pb-24'>
                <div className='py-6 text-center'>
                    <BringzzText tag='h1' className='text-center'>{segments?.[activeStep]?.status || 'Processing'}</BringzzText>
                    {/* TODO: Refactor this crap */}
                    {(orderDetails.type == ORDER_TYPES.MAIL_DELIVERY || orderDetails.type == ORDER_TYPES.CLICK_AND_COLLECT) && activeStep == 2 &&
                     (
                        <BringzzText tag='h3'>on {formatOrderReadyTime(orderDetails?.orderReadyAt)}</BringzzText> // on because there is "Order got ready" in front of it in another component
                     )
                    }

                    {(orderDetails.type == ORDER_TYPES.BRINGZZ_PICKUP) && activeStep == 2 &&
                     (
                        <BringzzText tag='h3'>Ready at {formatOrderReadyTime(orderDetails?.orderReadyAt)}</BringzzText> // nothing in front of it
                     )
                    }

                    {orderDetails.type == ORDER_TYPES.MAIL_DELIVERY && activeStep == 3 &&
                     (
                        <BringzzText tag='h3'>Dispatched {formatOrderReadyTime(orderDetails?.orderDispatchedAt)}</BringzzText>
                     )
                    }
                    {orderDetails.type == ORDER_TYPES.MAIL_DELIVERY && (activeStep == 4 || activeStep == 5) &&
                     (
                        <BringzzText tag='h3'>Delivered {formatOrderReadyTime(orderDetails?.orderDeliveredAt)}</BringzzText>
                     )
                    }
                    {orderDetails.type == ORDER_TYPES.BRINGZZ_PICKUP && (activeStep == 8 || activeStep == 9) &&
                     (
                        <BringzzText tag='h3'>on {formatOrderReadyTime(orderDetails?.orderConfirmedAt)}</BringzzText> // start with "Pharmacist confirmed the order"
                     )
                    }
                    {orderDetails.type == ORDER_TYPES.BRINGZZ_PICKUP && (activeStep == 10) &&
                     (
                        <BringzzText tag='h3'>Delivered {formatOrderReadyTime(orderDetails?.orderDeliveredAt)}</BringzzText> // start with "Shopper has arrived"
                     )
                    }
                    {orderDetails.type == ORDER_TYPES.BRINGZZ_PICKUP && (activeStep == 12) &&
                     (
                        <BringzzText tag='h3'>Delivered {formatOrderReadyTime(orderDetails?.orderDeliveredAt)}</BringzzText> // start with "Shopper has arrived"
                     )
                    }
                    <BringzzText tag='h3' className='text-center font-normal'>{segments?.[activeStep]?.subStatus || ''}</BringzzText>
                </div>

                <BringzzProgressBar state={Number(activeStep) + 1} mode={"custom"} segments={segments} />

                {/* {activeStep > 3 && <div className='flex items-center justify-between pb-4 px-8 cursor-pointer'>
                    <BringzzText tag='h4'>Add Tip</BringzzText>
                    <div className='flex items-center gap-x-3'>
                        <BringzzButton
                            className={`text-olive-green rounded-lg !px-3 flex justify-center font-semibold ${selectedTip === 1 ? 'bg-magic-lilac' : 'bg-sand '}`}
                            onClick={() => selectTip(1)}
                        >
                            €1
                        </BringzzButton>
                        <BringzzButton
                            className={`text-olive-green rounded-lg !px-3 flex justify-center font-semibold ${selectedTip === 3 ? 'bg-magic-lilac ' : 'bg-sand '}`}
                            onClick={() => selectTip(3)}
                        >
                            €3
                        </BringzzButton>
                        <BringzzButton
                            className={`text-olive-green rounded-lg !px-3 flex justify-center font-semibold ${selectedTip === 5 ? 'bg-magic-lilac' : 'bg-sand '}`}
                            onClick={() => selectTip(5)}
                        >
                            €5
                        </BringzzButton>
                        <BringzzButton
                            className={`text-olive-green rounded-lg !px-3 flex justify-center font-semibold ${selectedTip === 'Other' ? 'bg-magic-lilac' : 'bg-sand '}`}
                            onClick={e => {
                                e.stopPropagation();
                                selectTip('Other');
                            }}
                        >
                            Other
                        </BringzzButton>
                    </div>
                </div>} */}

                <BringzzOrderCardSmallAccordion
                    totalPrice={orderDetails?.totalPrice ? parseFloat(orderDetails.totalPrice) : 0}
                    products={orderDetails?.products || []}
                    fees={orderDetails?.fees.totalFees || {}}
                />

                {(DELIVERY_TYPES.BRINGZZ_PICKUP == orderDetails?.type || DELIVERY_TYPES.MAIL_DELIVERY == orderDetails?.type) && <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconMapMarker'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className='flex w-full justify-between'>
                        <div>
                            <BringzzText tag='h3'>Delivering to</BringzzText>
                            <BringzzText tag='h4' className={"font-light"}>Home</BringzzText>
                        </div>
                    </div>
                </div>}
                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconTicketAlt'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className='flex w-full justify-between'>
                        <div>
                            <BringzzText tag='h3'>Invoice</BringzzText>
                            <BringzzText tag='h4' className={'font-normal'}>
                                invoice {modalInvoice?.invoiceNumber ? `${new Date().getFullYear()}-${modalInvoice.invoiceNumber}` : '-'}
                            </BringzzText>
                        </div>
                        <div className='flex items-center space-x-2'>
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconEye'
                                size='22'
                                className='cursor-pointer'
                                onClick={handleShowInvoiceModal}
                            />
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconUpload'
                                className={activeStep < 7 ? 'text-black/30' : ''}
                                size='16' />
                        </div>
                    </div>
                </div>

                {/* Prescription Section - Always show but with opacity when no prescription */}
                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconFile'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className={`flex w-full justify-between ${!((orderDetails?.prescription && (Array.isArray(orderDetails.prescription) ? orderDetails.prescription.length > 0 : Object.keys(orderDetails.prescription).length > 0)) || prescriptionInfo) ? 'opacity-35' : ''}`}>
                        <div>
                            <BringzzText tag='h3'>Prescription</BringzzText>
                            <BringzzText tag='h4' className={"font-normal"}>
                                {orderDetails?.prescription?.prescriptionId || prescriptionInfo?.rezId || 'N/A'}
                            </BringzzText>
                        </div>
                        <div className='flex items-center space-x-2'>
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconEye'
                                size='22'
                                className={((orderDetails?.prescription && (Array.isArray(orderDetails.prescription) ? orderDetails.prescription.length > 0 : Object.keys(orderDetails.prescription).length > 0)) || prescriptionInfo) ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}
                                onClick={() => ((orderDetails?.prescription && (Array.isArray(orderDetails.prescription) ? orderDetails.prescription.length > 0 : Object.keys(orderDetails.prescription).length > 0)) || prescriptionInfo) && setShowPrescriptionModal(true)} />
                        </div>
                    </div>
                </div>

                {orderDetails?.pharmacy && orderDetails?.pharmacist && <BringzzPharmacyCardSmall pharmacy={orderDetails.pharmacy} pharmacist={orderDetails.pharmacist} />}

                {orderDetails?.type == DELIVERY_TYPES.BRINGZZ_PICKUP && orderDetails?.shopper && <BringzzShopperCardSmall shopper={orderDetails.shopper} />}

                <BringzzButton size='md' className='border border-red-600 text-red-600 mt-4' onClick={handleCancelOrderDrawer}>Cancel order</BringzzButton>
            </div>

            <BringzzBottomDrawer
                title='Cancel order'
                isOpen={cancelOrderDrawer}
                close={handleCancelOrderDrawer}
            >
                <div className='px-6 pb-6 space-y-4'>
                    <div>
                        <BringzzText tag='h4' className='font-normal'>Let us know why you are cancelling your order.</BringzzText>
                        <BringzzText tag='h4' className='font-normal'>Keep in mind <span onClick={handleShowOverlay} className='cursor-pointer underline'>cancellation fees</span> can apply.</BringzzText>
                    </div>
                    <div className='space-y-2'>
                        <div className='px-4'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setSelectedReason(newValue)
                                }}
                                state={state}
                                className="rounded-xl w-full text-center space-y-2"

                            >
                                <BringzzRadio value="1"
                                    className="p-2 py-2 hover:bg-slate- border rounded-md border-gray-400 flex"
                                >
                                    <BringzzText tag='h4'>Ordered by mistake</BringzzText>
                                </BringzzRadio>
                                <BringzzRadio value="2"
                                    className="p-2 py-2 hover:bg-slate- border rounded-md border-gray-400 flex"
                                >
                                    <BringzzText tag='h4'>{"Pharmacy/shopper didn't respond"}</BringzzText>
                                </BringzzRadio>
                            </BringzzRadioList>
                            <div className='mt-2'>
                                <BringzzInput placeholder={'Your custom reason'} className='border' onChange={(e, newIsValid, newValue) => {
                                    setSelectedReason(newValue)
                                }}></BringzzInput>
                            </div>
                        </div>
                        <BringzzButton onClick={handleCancelOrder} size='md' disabled={!selectedReason || loading} className='bg-magic-lilac w-full flex justify-center'>Cancel order</BringzzButton>
                        <BringzzButton onClick={handleCancelOrderDrawer} size='md' className='text-magic-lilac border border-magic-lilac w-full flex justify-center'>Cancel</BringzzButton>
                    </div>
                </div>
            </BringzzBottomDrawer>

            {showInvoiceModal && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-8 max-w-lg w-full relative">
                        <button className="absolute top-2 right-2 text-2xl" onClick={() => setShowInvoiceModal(false)}>&times;</button>
                        <BringzzText tag="h3" className="mb-4">Invoice Details</BringzzText>
                        {modalLoading && <BringzzText>Loading...</BringzzText>}
                        {modalError && <BringzzText className="text-red-600">{modalError}</BringzzText>}
                        {modalInvoice && <InvoiceView invoice={modalInvoice} onDownload={handleDownloadModalInvoice} showDownload={true}/>}
                    </div>
                </div>
            )}

            {/* Prescription Image Viewer Modal */}
            <ImageViewerModal
                isOpen={showPrescriptionModal}
                onClose={() => setShowPrescriptionModal(false)}
                imageUrl={orderDetails?.prescription?.photo || prescriptionInfo?.prescriptionImageUrl || prescriptionInfo?.photo || null}
                title="Prescription"
            />
        </BringzzPageContainer >
    );
};

export default MatchmakingCustomerPage;